<template>
  <div>
    <v-layout row wrap align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="elevation-12" v-if="!getCode">
          <v-toolbar dark>
            <v-toolbar-title>
              Login
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="codeForm" lazy-validation>
              <v-text-field required validate-on-blur :rules="codeRules" v-model="code" :error-messages="errors.code" prepend-icon="lock" name="code" :label="$vuetify.t('$vuetify.lobis.insertCode')" id="code" type="text"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn dark @click="getCode = true">{{ $vuetify.t('$vuetify.lobis.request_code') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark @click="login()">{{ $vuetify.t('$vuetify.lobis.login') }}</v-btn>
          </v-card-actions>
        </v-card>
        <v-card class="elevation-12" v-else>
          <v-toolbar dark>
            <v-toolbar-title>
              {{ $vuetify.t('$vuetify.lobis.request_code') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="numberForm" lazy-validation>
              <v-text-field v-model="phone_number" validate-on-blur :rules="numberRules" :error-messages="errors.phone_number" prepend-icon="phone" name="phone_number" label="Telefonnummer eingeben" id="phone_number" type="tel"></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn dark @click="getCode = false">{{ $vuetify.t('$vuetify.lobis.go_back') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn dark @click="requestCode()">{{ $vuetify.t('$vuetify.lobis.request_code') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import {AUTH_REQUEST, AUTH_GETCODE} from '../store/actions/auth'
export default {
  name: 'login',
  data () {
    return {
      valid: true,
      getCode: false,
      code: '',
      phone_number: '',
      codeRules: [
        v => !!v || this.$vuetify.t('$vuetify.lobis.code_requeired')
      ],
      numberRules: [
        v => !!v || this.$vuetify.t('$vuetify.lobis.phonenumber_requeired')
      ]
    }
  },
  mounted () {
    this.code = this.$route.params.code
    if (this.code) {
      this.$nextTick(() => {
        this.login()
      })
    }
  },
  computed: {
    errors () {
      if (this._.isEmpty(this.$store.state.auth.errors)) {
        return {}
      }
      return this.$store.state.auth.errors.errors
    }
  },
  methods: {
    login: function () {
      if (this.$refs.codeForm.validate()) {
        this.$store.dispatch(AUTH_REQUEST, this.code).then(() => {
          this.$router.push('/')
        })
      }
    },
    requestCode: function () {
      if (this.$refs.numberForm.validate()) {
        this.$store.dispatch(AUTH_GETCODE, this.phone_number).then(() => {
          this.getCode = false
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue